import { log_level_set } from "./globals.coffee"
import * as FFI from "./ffi.coffee"

logger_initialized = false

export logger_initialize = (log_level, skip_if_already_initialized=false) ->
	if !logger_initialized || !skip_if_already_initialized
		result = FFI.hakuban_logger_initialize(log_level)
		if result.status == 0
			logger_initialized = true
			log_level_set(log_level)
		else
			console.error "Failed to initialize logger, error " + result.error_message
